<template>
  <aside class="sidebar" role="sidebar">
    <div class="inner-sidebar">
      <div class="sidebar-header d-xl-none">
        <slot name="header" />
      </div>
      <div v-if="!hideSearch" class="sidebar-search">
        <Search v-model="keywords" @search="doSearch()" />
      </div>
      <div class="sidebar-filters">
        <Filters
          :currentFilters="currentFilters"
          :filterTypes="filterTypes"
          @add-filter="addFilter"
          @remove-filter="removeFilter"
          @remove-all-filters="removeAllFilters"
        />
        <slot name="custom-filters" :filters="currentFilters" />
      </div>
    </div>
  </aside>
</template>

<script>
import Search from "./Search";
import Filters from "./Filters";
export default {
  components: { Search, Filters },
  props: {
    currentKeywords: { type: String },
    currentFilters: { type: Array, default: () => [] },
    filterTypes: { type: Array, default: () => [] },
    hideSearch: { type: Boolean, default: false },
  },
  data() {
    return {
      keywords: "",
    };
  },
  computed: {
    hasActiveFilters() {
      return this.currentFilters.length > 0;
    },
  },
  watch: {
    currentKeywords(val) {
      this.keywords = val;
    },
  },
  methods: {
    doSearch() {
      this.$emit("search", this.keywords);
    },
    addFilter(type, value) {
      this.$emit("add-filter", type, value);
    },
    removeFilter(type, value) {
      this.$emit("remove-filter", type, value);
    },
    removeAllFilters() {
      this.$emit("remove-all-filters");
    },
  },
  mounted() {
    this.keywords = this.currentKeywords;
  },
};
</script>
